import React from 'react';

interface GuaranteeBadgeProps {
    imageUrl?: string;
    title?: string;
    description?: string;
}

const GuaranteeBadge: React.FC<GuaranteeBadgeProps> = ( {
    imageUrl,
    title,
    description,
} ) => {
    if ( !title && !description && !imageUrl ) {
        return <></>;
    }

    return (
        <div className="flex items-center grow mb-6 max-w-lg">
            {imageUrl && (
                <div className="mr-4 flex-shrink-0">
                    <img src={imageUrl} className="w-full max-w-28 h-auto" alt={title}/>
                </div>
            )}
            <div>
                {title && <h3 className="text-base font-semibold mb-2 text-left text-[--cfw-tb-guarantee-title]">{title}</h3>}
                {description && <p className="text-sm text-left text-[--cfw-tb-guarantee-content]" dangerouslySetInnerHTML={{ __html: description }}></p>}
            </div>
        </div>
    );
};

export default GuaranteeBadge;
